/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Service unavailable model
 * @export
 * @interface ServiceUnavailable
 */
export interface ServiceUnavailable {
    /**
     * Service unavailable message
     * @type {string}
     * @memberof ServiceUnavailable
     */
    error: string;
}

/**
 * Check if a given object implements the ServiceUnavailable interface.
 */
export function instanceOfServiceUnavailable(value: object): value is ServiceUnavailable {
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ServiceUnavailableFromJSON(json: any): ServiceUnavailable {
    return ServiceUnavailableFromJSONTyped(json, false);
}

export function ServiceUnavailableFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceUnavailable {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'],
    };
}

export function ServiceUnavailableToJSON(json: any): ServiceUnavailable {
    return ServiceUnavailableToJSONTyped(json, false);
}

export function ServiceUnavailableToJSONTyped(value?: ServiceUnavailable | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

